// extracted by mini-css-extract-plugin
export default {"containerMain":"VideoPageConv_containerMain__oMuXg","video":"VideoPageConv_video__2VESt","containerDados":"VideoPageConv_containerDados__Tff7r"};